import { render, staticRenderFns } from "./qianyidong.vue?vue&type=template&id=0da7bbf6&scoped=true&"
import script from "./qianyidong.vue?vue&type=script&lang=js&"
export * from "./qianyidong.vue?vue&type=script&lang=js&"
import style0 from "./qianyidong.vue?vue&type=style&index=0&id=0da7bbf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7bbf6",
  null
  
)

export default component.exports